// What kind of template this is, for the small tag on template cards: a PDF the
// fields are placed on, or a text template (pasted text with merge fields).
export function templateTypeLabel(template) {
  return template?.source_format === 'html' ? 'Text' : 'PDF';
}

// The tag's colours follow the type, not the Candidate / Placement / Contact
// column the card sits in: PDF is red, Text is a medium blue.
export function templateTypeTagClass(template) {
  return template?.source_format === 'html' ? 'bg-blue-600 text-white' : 'bg-red-600 text-white';
}
